module.exports = __webpack_public_path__ + "img/logo_only_image.ed6ac6b.svg";